/**
 * What the 2D light pass publishes to the canvas beneath it: the accumulation each item placement
 * reads, and the declarations a light or an item makes to shape them. `CanvasLightPass.tsx` says
 * why each light list has its own buffer.
 */
import { createContext, useContext } from 'react';
import * as THREE from 'three';
/** The lighting outside a 2D light pass: no lists, and every declaration a no-op. */
export const INERT_CANVAS_LIGHTING = {
    lists: new Map(),
    resolution: new THREE.Vector2(1, 1),
    registerLight: (_declaration) => ({ ordinal: 0, release: () => { } }),
    registerItem: (_placement, _read) => () => { },
    registerCappedItem: (_item) => () => { },
    registerApartPlacer: (_ordinal, _placer) => () => { },
    registerPassMesh: (_mesh, _ordinal, _role) => () => { },
    registerPassStep: (_step) => () => { },
};
export const CanvasLighting2DContext = createContext(INERT_CANVAS_LIGHTING);
/** The lighting in force, or an inert value outside a 2D stage (3D, unit tests). */
export function useCanvasLighting2D() {
    return useContext(CanvasLighting2DContext);
}
//# sourceMappingURL=lightPassContext.js.map